// extracted by mini-css-extract-plugin
module.exports = {"listIcons":"c7_sb","listIcons_size_lg":"c7_sc","listIcons__item":"c7_sd","listIcons__icon":"c7_sf"};